import { Moon, Sun } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useTheme } from '@/providers/ThemeProvider'

/** sliding sun/moon switch that toggles the app between the light and dark themes */
export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme()
  const isDark = theme === 'dark'

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      data-testid="header-theme-toggle"
      onClick={toggleTheme}
      className={cn(
        'relative inline-flex h-7 w-[3.25rem] shrink-0 items-center rounded-full',
        'bg-muted transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background'
      )}
    >
      {/* track icons — the one not covered by the knob stays visible */}
      <Sun className="absolute left-[7px] h-3.5 w-3.5 text-muted-foreground" aria-hidden />
      <Moon className="absolute right-[7px] h-3.5 w-3.5 text-muted-foreground" aria-hidden />
      {/* sliding knob carrying the active theme's icon */}
      <span
        className={cn(
          'relative z-10 inline-flex h-6 w-6 items-center justify-center rounded-full',
          'border border-border bg-background text-foreground shadow-sm transition-transform',
          isDark ? 'translate-x-[26px]' : 'translate-x-[2px]'
        )}
      >
        {isDark ? (
          <Moon className="h-3.5 w-3.5" aria-hidden />
        ) : (
          <Sun className="h-3.5 w-3.5" aria-hidden />
        )}
      </span>
    </button>
  )
}
